module.exports = __webpack_public_path__ + "img/prayer-journal_B095GJ5QJG.b96f1d3e.jpg";